// extracted by mini-css-extract-plugin
export default {"modal":"CreateInterviewTemplateModal-module__modal__rEMP2","content":"CreateInterviewTemplateModal-module__content__Fi7Ye"};